import React, { useCallback, useMemo } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import { FolderTileProps } from '../types';
import useStyles from './useStyles';
import { formatItemCount } from './utils';

const FolderTileLayout: React.FC<FolderTileProps> = ({
  id,
  name,
  itemCount = 0,
  coverSigned,
  onClick,
  thumbnailHeight,
}) => {
  const classes = useStyles();

  const itemCountText = useMemo(
    () => formatItemCount(itemCount, true),
    [itemCount]
  );

  const truncatedName = useMemo(
    () => ((name?.length ?? 0) > 20 ? `${name!.slice(0, 20)}...` : name),
    [name]
  );

  const onFolderClick = useCallback(() => onClick?.(id), [onClick, id]);

  return (
    <Box id={id} className={classes.containerVertical}>
      <Box
        className={classes.thumbnailVertical}
        style={thumbnailHeight ? { height: thumbnailHeight } : undefined}
        onClick={onFolderClick}
      >
        {coverSigned ? (
          <img
            src={coverSigned}
            alt={name}
            className={classes.thumbnailImage}
          />
        ) : (
          <FolderIcon className={classes.folderIconLarge} />
        )}
      </Box>
      <Box className={classes.infoRow}>
        <FolderIcon className={classes.folderIconSmall} />
        <Tooltip title={(name?.length ?? 0) > 20 ? name : ''} placement="top">
          <Typography className={classes.nameVertical} variant="body2">
            {truncatedName}
          </Typography>
        </Tooltip>
        <Typography
          className={classes.multilineEllipsis}
          title={name}
          variant="body2"
        >
          {itemCountText}
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(FolderTileLayout);
